import React from 'react'

export interface IOwnProps extends google.maps.MarkerOptions {
  infoWindow?: google.maps.InfoWindow
  map?: google.maps.Map
}
export interface IStateProps {  }
export interface IDispatchProps { }

export type IProps = IOwnProps & IStateProps & IDispatchProps

const Marker: React.FC<IProps> = (props) => {
  const [marker, setMarker] = React.useState<google.maps.Marker>()
  const {infoWindow, map, ...rest} = props

  React.useEffect(() => {
    if (!marker) {
      setMarker(new google.maps.Marker())
    }

    // remove marker from map on unmount
    return () => {
      if (marker) {
        marker.setMap(null)
      }
    }
  }, [marker])

  React.useEffect(() => {
    if (marker) {
      marker.setOptions(rest)
      // Set the marker on the map if provided
      if (map) {
        marker.setMap(map)
      }
      if (infoWindow && rest.title) {
        marker.addListener('click', () => {
          infoWindow.close()
          infoWindow.setContent(marker.getTitle())
          infoWindow.open(marker.getMap(), marker)
        })
      }
    }
  }, [infoWindow, marker, map, rest])

  return null
}

export default Marker
